import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-kondgruppe-list-view',
  imports: [],
  templateUrl: './kondgruppe.list-view.html',
  styleUrls: ['./kondgruppe.list-view.css'],
})
export class KondgruppeListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
